import { Modal, ModalOverlay } from '@trm/ui-kit-admin';

import { type WhatsNewEntry, WhatsNewPanel } from './WhatsNewPanel';

export const WhatsNewModal = ({
  isOpen,
  entries,
  onClose,
}: {
  isOpen: boolean;
  entries: readonly WhatsNewEntry[];
  onClose: () => void;
}) => (
  <ModalOverlay
    isOpen={isOpen}
    isDismissable
    onOpenChange={(open) => {
      if (!open) onClose();
    }}
  >
    <Modal className="max-w-xl">
      <WhatsNewPanel entries={entries} onClose={onClose} />
    </Modal>
  </ModalOverlay>
);
